import { ItemDisplayData } from "../models/item-display-data";

export class CategoryHolder 
{
    public ID='';
    public Name='';
    public Description='';
    public Cover='';
    public Priority=0;

    public Itens=Array<ItemDisplayData>();
}
